export enum EditUserModalDialogMode {
  editEmployee, editEmployeeCredentials, addEmployee, addUser, editUser
}
